export const DistrictPerformanceByProductGroup = {
    "sections": [
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 13,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Sales Summary Per Product Group",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Product Group',
                  "columnName": 'ItemGroupCode',
                  "width": '250px',
                  "align": "left",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'LY Sales',
                  "columnName": 'LYSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "percent": true
                },
                {
                  "name": 'Target',
                  "columnName": 'TargetSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true,
                },
                {
                  "name": 'Performance %',
                  "columnName": 'Performance',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "percent": true
                }
              ],
              "title": "ItemGroupCode",
              "endpoint": "D19",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "DistrictManagerCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "ItemGroupCode",
                  "selectedTitle": "Product",
                  "visual": [
                    {
                      "columns": 12,
                      "rows": 2,
                      "visual": {
                        "id": 1,
                        "type": "combo",
                        "title": "Actual Vs. Target with % Performance",
                        "colorTheme": 'colorTheme1',
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                          "data": {
                            "series": [
                              {
                                "name": 'Sales',
                                "value": 'ActualSales',
                                "type": 'column'
                              },
                              {
                                "name": 'Target',
                                "value": 'TargetSales',
                                "type": 'column'
                              },
                              {
                                "name": 'Performance %',
                                "value": 'Performance',
                                "type": 'line',
                                "percent": true
                              }
                            ],
                            "title": "ItemName",
                            "endpoint": "D19.1",
                            "parameters": [
                              { "key": "FromMonth", "value": "" },
                              { "key": "FromYear", "value": "" },
                              { "key": "ToMonth", "value": "" },
                              { "key": "ToYear", "value": "" },
                              { "key": "DistrictManagerCode", "value": "" },
                              { "key": "ItemGroupCode", "value": "" },
                              { "key": "ConfigTypeCode", "value": "" }
                            ]
                          },
                          "context": {
                            "point": {
                              "onClick": {
  
                              }
                            }
                          }
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      }
    ]
  }